import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__title"
}
const _hoisted_3 = {
  key: 0,
  style: {"margin-top":"0"},
  class: "bi-tmpl-detail__right__cmpt__title"
}
const _hoisted_4 = {
  key: 1,
  style: {"margin-top":"0"},
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_5 = { style: {"text-align":"center","box-sizing":"border-box","padding-top":"16px","margin-bottom":"16px"} }

import { withDefaults } from 'vue';
import { BaseRadio, BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import PcModuleRanking from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-ranking/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-18-1',
  props: {
    showTitle: { type: Boolean, default: true },
    showSecordTitle: { type: Boolean, default: true },
    childKey: {}
  },
  setup(__props: any) {

const props = __props;

const TYPE_MAPPING = [
  {
    value: '12',
    com: 'pc-module-ranking-1',
    index: 1
  },
  {
    value: '7',
    com: 'pc-module-ranking-2',
    index: 2
  },
  {
    value: '13',
    com: 'pc-module-ranking-3',
    index: 3
  },
  {
    value: '14',
    com: 'pc-module-ranking-4',
    index: 4
  },
  {
    value: '101',
    com: 'pc-module-ranking-5',
    index: 5
  }
];

const cmpName = name => {
  return PcModuleRanking.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, group } = useDetailCmpt({
  childKey: props.childKey
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(curItem).title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.showSecordTitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 请选择表格样式 "))
        : _createCommentVNode("", true),
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 1000,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group)(TYPE_MAPPING, 1), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"width":"100%"},
            key: index
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (child) => {
              return (_openBlock(), _createElementBlock("div", {
                key: child.value
              }, [
                _createVNode(_unref(BaseCard), {
                  style: _normalizeStyle({
              width: child.value === 'pc-module-ranking-5' ? '406px' : '421px',
              height: '445px',
              textAlign: 'center'
            }),
                  onClick: ($event: any) => (_unref(onChange)(child.value))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(child.com))))
                  ]),
                  _: 2
                }, 1032, ["style", "onClick"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(BaseRadio), {
                    value: child.value,
                    "model-value": _unref(curItem).value
                  }, null, 8, ["value", "model-value"])
                ])
              ]))
            }), 128))
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})